// import React, { useContext, useRef, useState } from 'react'
// import "react-image-gallery/styles/css/image-gallery.css";
// import Slider from "react-slick";
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
// import Modal from 'react-modal';
// import { ConfigContext } from '../../../Context/ConfigContext';

// const customStyles = {
//     content: {
//         top: '50%',
//         left: '50%',
//         right: 'auto',
//         bottom: 'auto',
//         marginRight: '-50%',
//         transform: 'translate(-50%, -50%)',
//         backgroundColor: '#f9fafb',
//         borderRadius: '10px',
//         zIndex: 10000
//     },
//     overlay: { zIndex: 100000 },
// };

// const OilPartsImages = ({ productGallery }) => {

//     console.log("productGallery ===>", productGallery)

//     const { apiURL, gdcURL } = useContext(ConfigContext);
//     const [activeSliderIndex, setActiveSliderIndex] = useState(0);
//     const [modalIsOpen, setIsOpen] = useState(false);
//     const [selectedImg, setSelectedImg] = useState(0);



//     function openModal() {
//         setIsOpen(true);
//     }

//     function afterOpenModal() { }

//     function closeModal() {
//         setIsOpen(false);
//     }

//     function SampleNextArrow(props) {
//         const { className, style, onClick } = props;
//         return (
//             <div
//                 className={className}
//                 style={{ ...style, display: "block", background: "#000", borderRadius: '100px', paddingTop: '1px', right: '10px' }}
//                 onClick={onClick}
//             />
//         );
//     }

//     function SamplePrevArrow(props) {
//         const { className, style, onClick } = props;
//         return (
//             <div
//                 className={className}
//                 style={{ ...style, display: "block", background: "#000", borderRadius: '100px', paddingTop: '1px', left: '10px', zIndex: 1000000 }}
//                 onClick={onClick}
//             />
//         );
//     }

//     const handleMediaClick = (index) => {
//         setSelectedImg(index);
//     };

//     const Thumbnails = () => {
//         return (
//             <div
//                 style={{
//                     display: "flex",
//                     overflowX: "auto",
//                     overflowY: "hidden",
//                     padding: "10px",

//                     width: "500px",
//                     scrollbarWidth: "thin",
//                 }}
//             >
//                 {productGallery?.map((img, index) => {
//                     const ThumbnailItem = () => {
//                         const [hover, setHover] = React.useState(false);

//                         return (
//                             <div
//                                 key={`img-part-${index}`}
//                                 style={{
//                                     flex: "0 0 auto",
//                                     marginRight: "10px",
//                                     cursor: "pointer",
//                                     width: "100px",
//                                     height: "100px",
//                                     border: `1px solid ${hover ? "#ff8b40" : "#CCC"}`,
//                                     borderRadius: "6px",
//                                     transition: "border-color 0.3s",
//                                 }}
//                                 onMouseEnter={() => setHover(true)}
//                                 onMouseLeave={() => setHover(false)}
//                                 onClick={() => handleMediaClick(index)}
//                             >
//                                 <img
//                                     alt="Ghayar"
//                                     src={
//                                         img.ART_MEDIA_TYPE === "JPEG" ||
//                                             img.ART_MEDIA_TYPE === "JPG" ||
//                                             img.ART_MEDIA_TYPE === "PNG" ||
//                                             img.ART_MEDIA_TYPE === "GIF" ||
//                                             img.ART_MEDIA_TYPE === "WEBP"

//                                             ? img?.product_gallery_url
//                                             : `${apiURL}/public/placeholder_category.jpeg`
//                                     }
//                                     style={{
//                                         borderRadius: "6px",
//                                         width: "100%",
//                                         height: "100%",
//                                         objectFit: "cover",
//                                     }}
//                                 />
//                             </div>
//                         );
//                     };

//                     return <ThumbnailItem key={`thumb-${index}`} />;
//                 })}
//             </div>
//         );
//     };

//     const PictureFrame = () => {
//         return <div style={{ minHeight: '300px', textAlign: 'center' }} onClick={openModal}>
//             {
//                 productGallery && productGallery?.map((thumb, index) => {
//                     if (index === selectedImg) {

//                         if (
//                             thumb.ART_MEDIA_TYPE === "JPEG" ||
//                             thumb.ART_MEDIA_TYPE === "JPG" ||
//                             thumb.ART_MEDIA_TYPE === "PNG" ||
//                             thumb.ART_MEDIA_TYPE === "GIF" ||
//                             thumb.ART_MEDIA_TYPE === "WEBP"
//                         ) {
//                             return <ZoomableImage
//                                 key={`zoomable-${index}`}
//                                 src={thumb?.product_gallery_url}
//                             />
//                         } else if (thumb.ART_MEDIA_TYPE === "URL") {
//                             return <embed
//                                 src={thumb.ART_MEDIA_HIPPERLINK.replaceAll('http:', 'https:')}
//                                 type="application/pdf"
//                                 style={{
//                                     minHeight: '360px',
//                                     height: "auto",
//                                     width: "70%",
//                                     margin: 'auto',
//                                     float: 'none'
//                                 }}
//                             />
//                         }
//                     }
//                 })
//             }
//         </div>
//     }

//     var settings = {
//         dots: false,
//         infinite: true,
//         speed: 500,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         afterChange: (current) => { setActiveSliderIndex(current); },
//         beforeChange: (current, next) => { },
//         nextArrow: <SampleNextArrow />,
//         prevArrow: <SamplePrevArrow />
//     };

//     let sliderRef = useRef();

//     const ZoomableImage = ({ src }) => {
//         const [scale, setScale] = React.useState(1);
//         const [origin, setOrigin] = React.useState("50% 50%");

//         const handleMouseMove = (e) => {
//             const rect = e.currentTarget.getBoundingClientRect();
//             const offsetX = e.clientX - rect.left;
//             const offsetY = e.clientY - rect.top;

//             const x = (offsetX / rect.width) * 100;
//             const y = (offsetY / rect.height) * 100;

//             setOrigin(`${x}% ${y}%`);
//         };

//         return (
//             <div
//                 style={{
//                     width: "450px",
//                     height: "450px",
//                     margin: "auto",
//                     overflow: "hidden",
//                     position: "relative",
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     cursor: "zoom-in",
//                 }}
//                 onMouseEnter={() => setScale(2)}
//                 onMouseMove={handleMouseMove}
//                 onMouseLeave={() => setScale(1)}
//             >
//                 <img
//                     alt="Ghayar"
//                     src={src ? src : `${apiURL}/public/placeholder_category.jpeg`}
//                     style={{
//                         width: "auto",
//                         height: "100%",
//                         transform: `scale(${scale})`,
//                         transformOrigin: origin,
//                         transition: "transform 0.1s ease",
//                         display: "block",
//                     }}
//                 />
//             </div>
//         );
//     };

//     // Usage inside Slider
//     <Slider
//         ref={(slider) => {
//             sliderRef = slider;
//         }}
//         style={{ backgroundColor: "#FFF" }}
//         {...settings}
//     >
//         {productGallery &&
//             productGallery?.map((thumb, index) => (
//                 <ZoomableImage
//                     key={`zoomable-${index}`}
//                     src={thumb?.product_gallery_url}
//                 />
//             ))}
//     </Slider>

//     return (
//         <div >
//             <PictureFrame />
//             <Thumbnails />

//             <Modal
//                 isOpen={modalIsOpen}
//                 onAfterOpen={afterOpenModal}
//                 onRequestClose={closeModal}
//                 style={customStyles}
//                 contentLabel="Example Modal"

//             >
//                 <div className="image-slider-container" style={{ width: '800px', }}>
//                     {/* <div style={{ fontFamily: 'Montserrat, Arial, sans-serif', fontSize: '22px', fontWeight: '500 !important', lineHeight: '0', color: '#000', height: '20px', marginTop: '15px' }}>{TITLE}</div> */}
//                     {/* <div style={{ color: '#59666e', fontSize: '12px', textAlign: 'left' }}>Part Number: {PART_NUMBER}</div> */}
//                     <Slider
//                         ref={(slider) => {
//                             sliderRef = slider;
//                         }}
//                         style={{ backgroundColor: "#FFF" }}
//                         {...settings}
//                     >
//                         {productGallery &&
//                             productGallery?.filter(media => media.ART_MEDIA_TYPE !== "URL" && media.ART_MEDIA_TYPE !== "PDF").map((thumb, index) => (
//                                 <ZoomableImage
//                                     key={`zoomable-${index}`}
//                                     src={`${thumb.product_gallery_url}`}
//                                 />
//                             ))}
//                     </Slider>
//                     <br />
//                     <span>{productGallery && productGallery.filter(media => media.ART_MEDIA_TYPE !== "URL" && media.ART_MEDIA_TYPE !== "PDF").length} Images</span>
//                     <br />
//                     <div
//                         style={{
//                             display: "flex",
//                             overflowY: "hidden",
//                             padding: "10px",
//                             marginTop: "10px",
//                             width: "800px",
//                             scrollbarWidth: "thin",
//                         }}
//                     >
//                         {productGallery.filter(media => media.ART_MEDIA_TYPE !== "URL" && media.ART_MEDIA_TYPE !== "PDF").map((img, index) => {
//                             const ThumbnailItem = () => {
//                                 const [hover, setHover] = React.useState(false);

//                                 return (
//                                     <div
//                                         key={`img-part-${index}`}
//                                         style={{
//                                             flex: "0 0 auto",
//                                             marginRight: "10px",
//                                             cursor: "pointer",
//                                             width: "150px",
//                                             height: "150px",
//                                             border: `1px solid ${hover ? "#ff8b40" : "#CCC"}`,
//                                             borderRadius: "6px",
//                                             transition: "border-color 0.3s",
//                                         }}
//                                         onMouseEnter={() => setHover(true)}
//                                         onMouseLeave={() => setHover(false)}
//                                         onClick={() => { setActiveSliderIndex(index); sliderRef.slickGoTo(index); }}
//                                     >
//                                         <img
//                                             alt="Ghayar"
//                                             src={
//                                                 img.ART_MEDIA_TYPE === "JPEG" ||
//                                                     img.ART_MEDIA_TYPE === "JPG" ||
//                                                     img.ART_MEDIA_TYPE === "PNG" ||
//                                                     img.ART_MEDIA_TYPE === "GIF" ||
//                                                     img.ART_MEDIA_TYPE === "WEBP"
//                                                     ? img?.product_gallery_url
//                                                     : `${apiURL}/public/placeholder_category.jpeg`
//                                             }
//                                             width={150}
//                                             height={150}
//                                             style={{ borderRadius: "6px" }}
//                                         />
//                                     </div>
//                                 );
//                             };

//                             return <ThumbnailItem key={`thumb-${index}`} />;
//                         })}

//                     </div>

//                 </div>
//                 <span style={{
//                     top: '5px',
//                     right: '10px',
//                     position: 'absolute',
//                     cursor: 'pointer'
//                 }}
//                     onClick={closeModal}>
//                     <i className="fa fa-times" aria-hidden="true"></i>
//                 </span>
//             </Modal>
//         </div>
//     )
// }

// export default OilPartsImages



import React, { useContext, useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import Modal from "react-modal";
import { ConfigContext } from "../../../Context/ConfigContext";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

Modal.setAppElement("#root");
Modal.defaultStyles.overlay.position = "fixed";

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#f9fafb",
        borderRadius: "10px",
        zIndex: 9999999999,
        padding: "20px",
        overflow: "hidden",
        border: "none",
        position: "absolute",
    },
    overlay: {
        position: "fixed",
        inset: 0,
        zIndex: 999999999,
        backgroundColor: "rgba(0,0,0,0.93)",
    },
};

const OilPartsImages = ({ productGallery, setSticky = () => { } }) => {
    const { apiURL } = useContext(ConfigContext);

    const [selectedImg, setSelectedImg] = useState(0);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [activeSliderIndex, setActiveSliderIndex] = useState(0);

    const sliderRef = useRef(null);

    const filteredMedia =
        productGallery?.filter(
            (media) => media.ART_MEDIA_TYPE !== "URL" && media.ART_MEDIA_TYPE !== "PDF"
        ) || [];

    function openModal() {
        setSticky(false);
        setIsOpen(true);

        setTimeout(() => {
            sliderRef.current?.slickGoTo(selectedImg);
        }, 150);
    }

    function closeModal() {
        setSticky(true);
        setIsOpen(false);
    }

    // body lock + hide sticky elements
    useEffect(() => {
        const siteHeader = document.querySelector("header");
        const navbar = document.querySelector(".navbar");
        const stickySearch = document.querySelector(".sticky-search");

        if (modalIsOpen) {
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

            document.body.style.overflow = "hidden";
            document.documentElement.style.overflow = "hidden";
            document.body.style.paddingRight = `${scrollbarWidth}px`;

            siteHeader && (siteHeader.style.visibility = "hidden");
            navbar && (navbar.style.visibility = "hidden");
            stickySearch && (stickySearch.style.visibility = "hidden");
        } else {
            document.body.style.overflow = "auto";
            document.documentElement.style.overflow = "auto";
            document.body.style.paddingRight = "0px";

            siteHeader && (siteHeader.style.visibility = "visible");
            navbar && (navbar.style.visibility = "visible");
            stickySearch && (stickySearch.style.visibility = "visible");
        }

        return () => {
            document.body.style.overflow = "auto";
            document.documentElement.style.overflow = "auto";
            document.body.style.paddingRight = "0px";

            siteHeader && (siteHeader.style.visibility = "visible");
            navbar && (navbar.style.visibility = "visible");
            stickySearch && (stickySearch.style.visibility = "visible");
        };
    }, [modalIsOpen]);

    // keyboard nav
    useEffect(() => {
        const handleKeyNavigation = (e) => {
            if (!modalIsOpen || !sliderRef.current) return;

            if (e.key === "ArrowRight") sliderRef.current.slickNext();
            if (e.key === "ArrowLeft") sliderRef.current.slickPrev();
            if (e.key === "Escape") closeModal();
        };

        window.addEventListener("keydown", handleKeyNavigation);
        return () => window.removeEventListener("keydown", handleKeyNavigation);
    }, [modalIsOpen]);

    const handleMediaClick = (index) => {
        setSelectedImg(index);
    };

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{
                    ...style,
                    display: "block",
                    background: "#000",
                    borderRadius: "100px",
                    right: "10px",
                }}
                onClick={onClick}
            />
        );
    }

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{
                    ...style,
                    display: "block",
                    background: "#000",
                    borderRadius: "100px",
                    left: "10px",
                    zIndex: 1000,
                }}
                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        afterChange: (current) => {
            setActiveSliderIndex(current);
            setSelectedImg(current);
        },
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
    };

    const ZoomableImage = ({ src }) => {
        const [scale, setScale] = useState(1);
        const [origin, setOrigin] = useState("50% 50%");

        const handleMouseMove = (e) => {
            const rect = e.currentTarget.getBoundingClientRect();
            const offsetX = e.clientX - rect.left;
            const offsetY = e.clientY - rect.top;

            const x = (offsetX / rect.width) * 100;
            const y = (offsetY / rect.height) * 100;

            setOrigin(`${x}% ${y}%`);
        };

        return (
            <div
                style={{
                    width: "450px",
                    height: "450px",
                    margin: "auto",
                    overflow: "hidden",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "zoom-in",
                }}
                onMouseEnter={() => setScale(2)}
                onMouseMove={handleMouseMove}
                onMouseLeave={() => setScale(1)}
            >
                <img
                    alt="Oil Product"
                    src={src || `${apiURL}/public/placeholder_category.jpeg`}
                    style={{
                        width: "auto",
                        height: "100%",
                        transform: `scale(${scale})`,
                        transformOrigin: origin,
                        transition: "transform 0.1s ease",
                    }}
                />
            </div>
        );
    };

    const PictureFrame = () => {
        if (!filteredMedia.length) return null;

        const thumb = filteredMedia[selectedImg];

        return (
            <div style={{ minHeight: "300px", textAlign: "center" }} onClick={openModal}>
                <ZoomableImage src={thumb.product_gallery_url} />
            </div>
        );
    };

    const Thumbnails = () => (
        <div
            style={{
                display: "flex",
                overflowX: "auto",
                overflowY: "hidden",
                padding: "10px",
                width: "500px",
                scrollbarWidth: "thin",
            }}
        >
            {filteredMedia.map((img, index) => (
                <div
                    key={index}
                    style={{
                        flex: "0 0 auto",
                        marginRight: "10px",
                        cursor: "pointer",
                        width: "100px",
                        height: "100px",
                        border: selectedImg === index ? "2px solid #ff8b40" : "1px solid #CCC",
                        borderRadius: "6px",
                    }}
                    onClick={() => handleMediaClick(index)}
                >
                    <img
                        alt="thumb"
                        src={img.product_gallery_url}
                        style={{
                            borderRadius: "6px",
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                        }}
                    />
                </div>
            ))}
        </div>
    );

    return (
        <div>
            <PictureFrame />
            <Thumbnails />

            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
            >
                <div className="image-slider-container mt-3" style={{ width: "800px" }}>
                    <Slider ref={sliderRef} {...settings}>
                        {filteredMedia.map((thumb, index) => (
                            <ZoomableImage key={index} src={thumb.product_gallery_url} />
                        ))}
                    </Slider>

                    <br />
                    <span>{filteredMedia.length} Images</span>

                    <div
                        style={{
                            display: "flex",
                            overflowX: "auto",
                            padding: "10px",
                            marginTop: "10px",
                            width: "800px",
                        }}
                    >
                        {filteredMedia.map((img, index) => (
                            <div
                                key={index}
                                style={{
                                    flex: "0 0 auto",
                                    marginRight: "10px",
                                    cursor: "pointer",
                                    width: "150px",
                                    height: "150px",
                                    border: activeSliderIndex === index ? "2px solid #ff8b40" : "1px solid #CCC",
                                    borderRadius: "6px",
                                }}
                                onClick={() => {
                                    setActiveSliderIndex(index);
                                    sliderRef.current?.slickGoTo(index);
                                }}
                            >
                                <img
                                    alt="thumb"
                                    src={img.product_gallery_url}
                                    width={150}
                                    height={150}
                                    style={{ borderRadius: "6px", objectFit: "cover" }}
                                />
                            </div>
                        ))}
                    </div>
                </div>

                <span
                    style={{
                        top: "20px",
                        right: "15px",
                        position: "absolute",
                        cursor: "pointer",
                        fontSize: "20px",
                    }}
                    onClick={closeModal}
                >
                    <i className="fa fa-times"></i>
                </span>
            </Modal>
        </div>
    );
};

export default OilPartsImages;